import { render, staticRenderFns } from "./roomType.vue?vue&type=template&id=ace32532&scoped=true&"
import script from "./roomType.vue?vue&type=script&lang=js&"
export * from "./roomType.vue?vue&type=script&lang=js&"
import style0 from "./roomType.vue?vue&type=style&index=0&id=ace32532&lang=less&scoped=true&"
import style1 from "./roomType.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace32532",
  null
  
)

export default component.exports